import { action } from '@ember/object';
import { debounce } from '@ember/runloop';
import Component from '@glimmer/component';

import CommonColorsAndThemesComponent from 'webapp/components/common/colors-and-themes';

import type ReportSlideFragment from 'webapp/models-custom/report-slide-fragment';

interface Args {
	model: ReportSlideFragment;
}

export default class ReportsEditorBlockCtBgColorComponent extends Component<Args> {
	@action
	changeColor(color: string): void {
		this.args.model.updateBlockColor(color);
		this.saveModel();
	}

	@action
	changeTheme(themeId: number): void {
		this.args.model.updateBlockThemeId(themeId);
		this.saveModel();
	}

	private saveModel(): void {
		const fragment = this.args.model;
		debounce<ReportSlideFragment, () => unknown>(fragment, fragment.saveAndCatch, 200);
	}
	<template>
		<div class="row">
			<label>Background color</label>
			<div class="right theme-dark tw:dark">
				<CommonColorsAndThemesComponent
					@selectedColor={{@model.blockColor}}
					@selectedTheme={{@model.blockThemeId}}
					@reportSlide={{null}}
					@onColorChange={{this.changeColor}}
					@onThemeChange={{this.changeTheme}}
				/>
			</div>
		</div>
	</template>
}
